/// <reference types="@angular/localize" />

import * as $ from 'jquery';
(window as any)['jQuery'] = $;
(window as any)['$'] = $;

// Bootstrap 5 dropped jQuery plugins — register Tooltip and Popover as jQuery
// plugins so Summernote BS5 can call $(el).tooltip() / $(el).popover()
($  as any).fn.tooltip = function (this: any, options: any) {
  return this.each(function (this: any) {
    const bs = (window as any).bootstrap;
    if (!bs?.Tooltip) return;
    if (typeof options === 'string') {
      const instance = bs.Tooltip.getInstance(this);
      if (instance) instance[options]();
    } else {
      new bs.Tooltip(this, Object.assign({ trigger: 'hover' }, options || {}));
    }
  });
};

($  as any).fn.popover = function (this: any, options: any) {
  return this.each(function (this: any) {
    const bs = (window as any).bootstrap;
    if (!bs?.Popover) return;
    if (typeof options === 'string') {
      const instance = bs.Popover.getInstance(this);
      if (instance) instance[options]();
    } else {
      new bs.Popover(this, options || {});
    }
  });
};

import 'summernote/dist/summernote-bs5.min.js';

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { defineCustomElements } from '@truckit/shared-ui/loader';

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

defineCustomElements(window);
